<template>
  <div class="uk-section">
    <div class="uk-container">
      <div class="uk-grid-match uk-child-width-1-3@m" uk-grid>
        <div v-for="post in this.posts" :key="post.id">
          <div class="uk-card uk-card-default uk-card-small" @click="displayPost(post)">
            <div class="uk-card-media-top">
              <img v-lazy="featuredImage(post)" :alt="post.title.rendered">
            </div>
            <div class="uk-card-body">
              <h2 class="uk-card-title" v-html="post.title.rendered"></h2>
              <div v-html="post.excerpt.rendered"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="section has-text-centered">
        <button class="uk-button uk-button-primary" @click="getPosts(page)">
          <span v-if="!isLoading">Load More Stories</span>
          <div class="uk-text-center" uk-spinner v-if="isLoading"></div>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../store'

export default {
  data () {
    return {
      page: 0,
      posts: store.posts,
      isLoading: false
    }
  },
  methods: {
    getPosts (page) {
      this.isLoading = true
      this.page ++
      axios.get('https://faithit.com/wp-json/wp/v2/posts?page=' + this.page)
      .then(response => {
        let result = response.data
        store.posts = result
        this.posts.push(...result)
        this.isLoading = false
      })
      .catch(e => {
        this.page --
        this.errors.push(e)
        console.log(e)
        this.isLoading = false
      })
    },
    displayPost (post) {
      store.selectedPost = post
      this.$router.push({
        name: 'post',
        params: {
          slug: post.slug
        }
      })
    },
    featuredImage: function (post) {
      return post.better_featured_image.source_url.replace(/(http:\/\/faithit\.com)/g, 'https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com')
    }
  },
  mounted () {
    if (!Array.isArray(this.posts) || !this.posts.length) {
      this.getPosts(this.page)
    }
  },
  filters: {
    cdn: function (value) {
      return value.replace('http://faithit.com', 'https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com')
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HomeView.vue